import { useEffect } from 'react'
import useDialogsStore from '../stores/dialogs'
import CancelRideDialog from '../components/dialogs/CancelRide/CancelRideDialog'
import CreateRideDialog from '../components/dialogs/CreateRide/CreateRideDialog'
import CreateUserDialog from '../components/dialogs/User/CreateUser'
import EditUserDialog from '../components/dialogs/User/EditUser'

const availableDialogs = {
  'cancel-ride-dialog': {
    component: CancelRideDialog
  },
  'create-ride': {
    component: CreateRideDialog
  },
  'create-user': {
    component: CreateUserDialog
  },
  'edit-user': {
    component: EditUserDialog
  }
}

function useDialog<T>(key: keyof typeof availableDialogs) {
  const setDialog = useDialogsStore(state => state.setDialog)
  const removeDialog = useDialogsStore(state => state.removeDialog)
  const closeDialog = useDialogsStore(state => state.closeDialog)

  useEffect(() => () => {
    removeDialog(key)
  }, [removeDialog, key])

  const handleCloseDialog = () => {
    closeDialog(key)
    setTimeout(() => {
      removeDialog(key)
    }, 500)
  }

  return (dialogProps?: Omit<T, 'onClose' | 'open'>) => {
    setDialog({
      key,
      component: availableDialogs[key].component,
      isOpen: true,
      props: {
        onClose: handleCloseDialog,
        ...dialogProps
      }
    })
  }
}

export default useDialog
